module.exports = __webpack_public_path__ + "static/media/EG-P01.c5bcd378.jpg";